import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Matin / soleil levant — soleil avec rayons duotone */
export const MorningIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Soleil rempli menthe */}
      <circle cx="12" cy="12" r="4.5" fill="var(--equiply-icon-bg)" />
      <circle cx="12" cy="12" r="4.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Rayons */}
      <path
        d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.5 5.5l1.4 1.4M17.1 17.1l1.4 1.4M5.5 18.5l1.4-1.4M17.1 6.9l1.4-1.4"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  ),
);
MorningIcon.displayName = "MorningIcon";
